import React, { useState } from "react";
import Device from "../models/Device";
import Logger from "../Logger";
import { useRedraw } from "../models/useRerender";
import { noItx, itx } from "../translationItx/itx";

const logger = new Logger();

type DebugItem = {
  refId: string;
  datas: Array<any> | undefined;
};

function findItem(
  device: Device,
  data: any,
  refId: string,
  instanceId: string,
  stack: Array<any>,
  result: Array<any>,
): Array<any> | undefined {
  for (let i in data.items) {
    const item = data.items[i];
    if (item && typeof item === "object") {
      if (item.a?.RefId == refId || (item["#name"] != "ParameterRef" && item.a?.Id == refId)) {
        result.push([...stack, { name: item["#name"], ...item.a }]);
      }

      let value: string | undefined = undefined;

      if (item["#name"] == "choose") {
        const id = item.a.ParamRefId;
        value = device.knxInstanceData.getValue(id, instanceId);
        if (value == undefined) {
          value = "--undefined--"; // no itx
        }

        value = `"${value}"`;
      }

      findItem(device, item, refId, instanceId, [...stack, { name: item["#name"], ...item.a, value: value }], result);
    }
  }
  return undefined;
}

export default function KnxDataAnalyser(props: { device: Device }) {
  const { device } = props;

  const [tab, setTab] = useState("structure"); // no itx
  const [items, setItems] = useState<DebugItem[]>([]);

  const redraw = useRedraw();

  async function addItem(refId: string, instanceId: string) {
    await device.template?.knxProductData.loadXmlData(device);
    const productData = device.template?.knxProductData;

    if (productData) {
      const xmlData1 = device.getApplicationProgram();

      if (xmlData1) {
        const result = new Array<any>();
        findItem(device, xmlData1, refId, instanceId, [], result);

        result.map((itemDatas) => {
          itemDatas;
          if (itemDatas && itemDatas.length > 0) {
            const parameterRefRef = itemDatas[itemDatas.length - 1];

            const parameterRef = productData.deref(parameterRefRef?.RefId);

            const id = parameterRef?.a.Id;

            if (id) {
              const CurrentValue = device.knxInstanceData.getValue(id, instanceId) || "--undefinded--";

              const parameter = productData.deref(parameterRef?.a.RefId);
              const parameterType = productData.deref(parameter?.a.ParameterType);

              itemDatas = [
                ...itemDatas,
                { name: "------- Parameter-Vererbung" }, // no itx
                { name: "parameterRef", CurrentValue: CurrentValue, ...parameterRef?.a }, // no itx
                { name: "parameter", ...parameter?.a }, // no itx
                { name: "ParameterType", parameterType }, // no itx
              ];
            }

            const newItem = { refId: refId, datas: itemDatas };
            setItems((currentItems) => [...currentItems, newItem]);
          }
        });

        redraw();
      }
    }
  }

  const itemElements: any = [];

  items.forEach((item) => {
    const rows: any = [];

    item.datas?.forEach((di) => {
      const lines: any = [];

      //

      const multiLine = false;
      if (multiLine) {
        JSON.stringify(di, null, 3)
          .split("\n")
          .map((ln) =>
            lines.push(
              <div style={{ paddingLeft: `${ln.lastIndexOf("  ") * 10}px` }}>
                {ln}
                <br />
              </div>,
            ),
          );
      } else {
        lines.push(<div>{JSON.stringify(di)}</div>);
      }

      rows.push(<div>{lines} </div>);
      // rows.push(<div>{JSON.stringify(di)} </div>);
    });

    itemElements.push(
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          whiteSpace: "nowrap",
        }}
      >
        {item.refId}
        <br />
        <br />
        {rows}
      </div>,
    );
  });

  const valueElms: any = [];

  device.knxInstanceData.debugParams = true;

  const pModules: any = device.knxInstanceData.modules;
  for (const m in pModules) {
    const pModule = pModules[m];

    const vElms: any = [];

    for (const v in pModule.params) {
      let val = pModule.params[v];
      if (val == undefined) {
        val = "-- undefinded --";
      }

      const level = val.valueLevel ?? "--";
      val = val.value;

      vElms.push(
        <div>
          {v}: &nbsp;&nbsp;{/* no itx */}
          {val} {noItx("Level:")} {level} {noItx(" referenced: ")}
          {device.knxInstanceData.isReferenced(v, m) ? noItx("yes") : noItx("no")}
        </div>,
      );
    }

    valueElms.push(
      <div style={{ display: "flex", flexDirection: "column" }}>
        {noItx("Module:")} {m}
        <div style={{ paddingLeft: "30px", paddingBottom: "20px" }}>{vElms}</div>
      </div>,
    );
  }

  valueElms.push(<div style={{ paddingTop: "20px" }}>{itx("KnxDataAnalyser.vars", "Vars")}</div>); // no itx

  const pParams: any = device.knxInstanceData.params;

  for (const v in pParams) {
    let val = pParams[v];

    const level = val.valueLevel ?? "--";
    val = val.value;

    valueElms.push(
      <div>
        {v}: &nbsp;&nbsp; {val} {noItx("Level:")} {level}
        {noItx(" referenced: ")} {device.knxInstanceData.isReferenced(v, "") ? noItx("yes") : noItx("no")}
      </div>,
    );
  }

  device.knxInstanceData.debugParams = false;

  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        overflow: "auto",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <div style={{ width: "100%", padding: "10px", backgroundColor: "#eee" }}>
        {" "}
        {state.translate("knxDataAnalyzer.title", "Knx Data-Analyser")}
      </div>

      <div style={{ display: "flex", flexDirection: "row", flexWrap: "nowrap", padding: "10px" }}>
        <button
          className="button"
          onClick={() => {
            setTab("structure"); // no itx
          }}
        >
          {" "}
          {noItx("Struktur")}{" "}
        </button>
        <button
          className="button"
          onClick={() => {
            setTab("values"); // no itx
          }}
        >
          {" "}
          {noItx("Values")}{" "}
        </button>
      </div>

      {tab == "values" && (
        <div style={{ width: "100%", padding: "10px" }}>
          {noItx("Values")}
          {valueElms}
        </div>
      )}

      {tab == "structure" && (
        <div>
          <div style={{ display: "flex", flexDirection: "row", flexWrap: "nowrap", padding: "10px" }}>
            <input id="dataAnalyserRefId" placeholder={state.translate("knxDataAnalyzer.refId", "RefId")} />
            <input id="dataAnalyserInstanceId" placeholder={itx("knxDataAnalyzer.instanceId", "InstanceId")} />

            <button
              onClick={() => {
                let elm = document.getElementById("dataAnalyserRefId") as HTMLInputElement;
                let refId = elm.value.trim();

                if (refId.startsWith(`"`)) {
                  const i = refId.indexOf(`"`, 1); // "MD-2_P-1_R-1/MD-2_M-1", // Grundeinstellung / Kanal-/Objektbeschreibung
                  refId = refId.substring(1, i);
                }

                const elm2 = document.getElementById("dataAnalyserInstanceId") as HTMLInputElement;
                let xInstanceId = elm2.value;

                const ss = refId.split("/");
                refId = ss[0];
                if (ss.length > 1) {
                  xInstanceId = ss[1];
                  elm2.value = xInstanceId;
                }

                elm.value = refId;

                addItem(refId, xInstanceId);
              }}
            >
              !
            </button>

            <button
              onClick={() => {
                setItems([]);
                redraw();
              }}
            >
              {state.translate("knxDataAnalyzer.clear", "Clear")}
            </button>
          </div>

          <div style={{ overflow: "auto" }}>
            <div>{itemElements}</div>
          </div>
        </div>
      )}
    </div>
  );
}
